module.exports = __webpack_public_path__ + "static/img/txt-7.a8f8593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/txt-7.png
// module id = y2CA
// module chunks = 0